"use client";
import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { useSpinner as p } from "./useSpinner.js";
const m = c((i, l) => {
  const { classList: e, label: s, getSpinnerProps: n } = p({
    ...i
  });
  return /* @__PURE__ */ a("div", { ref: l, ...n(), children: [
    /* @__PURE__ */ a("div", { className: e.wrapper, children: [
      /* @__PURE__ */ r("i", { className: e.circle1 }),
      /* @__PURE__ */ r("i", { className: e.circle2 })
    ] }),
    s && /* @__PURE__ */ r("span", { className: e.label, children: s })
  ] });
});
m.displayName = "Spinner";
export {
  m as default
};
